import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetOrganizations = (params) => axios.get(apiPaths.organizationsBase, { params });

const onGetOrganization = (organizationId) => axios.get(`${apiPaths.organizationsBase}/${organizationId}`);
const onCreateOrganization = (params) => axios.post(apiPaths.organizationsBase, params);
const onUpdateOrganization = (claimData) => axios.put(`${apiPaths.organizationsBase}/${claimData.id}`, claimData);

export { onGetOrganizations, onGetOrganization, onCreateOrganization, onUpdateOrganization };
